// extracted by mini-css-extract-plugin
module.exports = {"branding":"Ret7C","upgradePopup":"_1Ce6m","upgradePopupText":"_x-hn","upgradePopupButton":"_3K5aB"};